import { useTranslation } from 'react-i18next';
import { AlertTriangle, LogOut } from 'lucide-react';
import { useAuthStore } from '../stores/authStore';

export default function ImpersonationBanner() {
  const { t } = useTranslation();
  const isImpersonating = useAuthStore((s) => s.isImpersonating);
  const impersonationTenant = useAuthStore((s) => s.impersonationTenant);
  const user = useAuthStore((s) => s.user);
  const endImpersonation = useAuthStore((s) => s.endImpersonation);

  if (!isImpersonating) return null;

  const userName = user?.name || user?.username || '';
  const schoolName = impersonationTenant?.name_ar || impersonationTenant?.name_en || '';

  return (
    <div className="sticky top-0 inset-x-0 z-[60] bg-amber-500 text-white h-10 flex items-center justify-between px-4 shadow-md shrink-0">
      <div className="flex items-center gap-2 text-sm font-medium">
        <AlertTriangle size={16} />
        <span>
          {t('impersonation.banner', {
            defaultValue: `أنت تتصفح كـ ${userName} في ${schoolName} — جلسة مؤقتة`,
            user: userName,
            school: schoolName,
          })}
        </span>
      </div>
      <button
        onClick={endImpersonation}
        className="flex items-center gap-1.5 px-3 py-1 rounded-md bg-amber-600 hover:bg-amber-700 text-white text-sm font-medium transition-colors"
      >
        <LogOut size={14} />
        {t('impersonation.endSession', 'إنهاء الجلسة')}
      </button>
    </div>
  );
}
